/** Search params that open one foreclosure case and remember the title request. */

export type OperatorCasesSearch = {
  licenseId?: string;
  caseNumber?: string;
  countyFips?: string;
  returnTo?: string;
};

export type OperatorRegistrationsSearch = {
  licenseId?: string;
  returnTo?: string;
};

export type OperatorTitleRequestSearch = {
  requestId?: string;
};

function optionalSearchString(value: unknown): string | undefined {
  return typeof value === "string" && value.trim() ? value : undefined;
}

export function validateOperatorCasesSearch(
  search: Record<string, unknown>,
): OperatorCasesSearch {
  return {
    licenseId: optionalSearchString(search.licenseId),
    caseNumber: optionalSearchString(search.caseNumber),
    countyFips: optionalSearchString(search.countyFips),
    returnTo: optionalSearchString(search.returnTo),
  };
}

export function validateOperatorTitleRequestSearch(
  search: Record<string, unknown>,
): OperatorTitleRequestSearch {
  return {
    requestId: optionalSearchString(search.requestId),
  };
}

export function titleRequestCaseLinkSearch(
  requestId: string,
  item: { case_number: string; county_fips: string },
): OperatorCasesSearch {
  return {
    caseNumber: item.case_number,
    countyFips: item.county_fips,
    returnTo: titleRequestReturnTo(requestId),
  };
}

export function validateOperatorRegistrationsSearch(
  search: Record<string, unknown>,
): OperatorRegistrationsSearch {
  return {
    licenseId: optionalSearchString(search.licenseId),
    returnTo: optionalSearchString(search.returnTo),
  };
}

export function titleRequestLicenseLinkSearch(
  requestId: string,
  licenseId: string,
): OperatorRegistrationsSearch {
  return {
    licenseId,
    returnTo: titleRequestReturnTo(requestId),
  };
}

function titleRequestReturnTo(requestId: string): string {
  return `/operator/title-requests?requestId=${encodeURIComponent(requestId)}`;
}

/** Title request to reopen when a case dialog that was opened from one closes. */
export function titleRequestIdFromReturnTo(
  returnTo: string | undefined,
): string | null {
  if (!returnTo) return null;
  let url: URL;
  try {
    url = new URL(returnTo, "http://localhost");
  } catch {
    return null;
  }
  if (url.pathname !== "/operator/title-requests") return null;
  return url.searchParams.get("requestId");
}
